/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"

import Header from "./header"
// import "./layout.css"
import "./style.scss"
import GoetheImage from "./goethe-image"
import EnterImage from "./enter-image"

const Layout = ({ children }) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)

  return (
    <>
      <Header siteTitle={data.site.siteMetadata.title} />
      <div className="orange-background">
        <main>{children}</main>
        <footer
          className="section dark-section text-color-white"
          style={{ marginTop: "12px" }}
        >
          <div className="container">
            <div className="columns">
              <div className="column is-two-thirds is-size-5">
                <p style={{ marginBottom: "4rem" }}>
                  This audio story was researched, written and edited by{" "}
                  <a
                    href="https://carmenho.live"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Carmen Ho
                  </a>
                  ,{" "}
                  <a
                    href="https://runningdeveloper.com"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Geoffrey Hunt
                  </a>
                  ,{" "}
                  <a
                    href="http://tuism.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Steven Tu
                  </a>
                  ,{" "}
                  <a
                    href="https://www.linkedin.com/in/nathi-tshabalala-06466416/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Nathi Tshabalala
                  </a>{" "}
                  and{" "}
                  <a href="https://www.instagram.com/thabo_plingo_tsolo/" target="_blank" rel="noopener noreferrer">
                    Thabo Tsolo
                  </a>
                  . With voices by Carmen Ho,{" "}
                  <a href="https://www.instagram.com/Chazzlehippie/" target="_blank" rel="noopener noreferrer">
                    Charmaine Motlhabi
                  </a>
                  ,{" "}
                  <a
                    href="https://instagram.com/jack_ketana"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Jack Malloy
                  </a>{" "}
                  and{" "}
                  <a
                    href="https://twitter.com/ntombik7"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Ntombi Khanyile
                  </a>
                  . Walk with me is a project of{" "}
                  <a
                    href="http://www.enterafrica.org"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Enter Africa
                  </a>
                  , an initiative spanning 15 African countries in Africa,
                  started by the{" "}
                  <a
                    href="https://www.goethe.de"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Goethe-Institute
                  </a>
                </p>     
              </div>
              <div className="column">
                <div className="columns is-mobile">
                  <div className="column">
                    <div className="center-block">
                      <EnterImage />
                    </div>
                  </div>
                  <div className="column">
                    <div className="center-block">
                      <GoetheImage />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="columns">
              <div className="column">
              <small className="is-size-6">
                  © {new Date().getFullYear()},{` `} Enter Africa
                </small>
              </div>
            </div>
          </div>
        </footer>
      </div>
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
